// extracted by css-extract-rspack-plugin
export default {"timelineElement":"LayoutHelpers-module__timelineElement__ARvqv","nonLeadingElement":"LayoutHelpers-module__nonLeadingElement__BVtHX"};